var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_WeakMap.js
// module id = 1633
// module chunks = 3 9 13